var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"surface darken-1",style:(_vm.CSS_VARS),attrs:{"id":"loading-wrapper","tile":""}},[_c('div',{attrs:{"id":"loading-text"}},[_vm._v(_vm._s(_vm.$t('loadingText')))]),_c('div',{attrs:{"id":"loading-content"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }